const analyticsErrorPrefix = 'shared-software-dates';

export const PACKAGE_NAME = 'jiraSharedSoftwareDates';

export const TEAM_NAME = 'jira-werewolves';

export const FETCH_CONNECTED_PROJECTS = `${analyticsErrorPrefix}.fetch-connected-projects`;

export const CONNECT_PROJECTS = `${analyticsErrorPrefix}.connect-projects`;

export const DISCONNECT_PROJECTS = `${analyticsErrorPrefix}.disconnect-projects`;

export const CLIENT_ERROR_403 = 'Server responded with 403';

export const CLIENT_ERROR_404 = 'Server responded with 404';
